var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'card')?_c('EntityAccessTypeCardIcon'):(_vm.type === 'free')?_c('EntityAccessTypeFreeIcon'):(_vm.type === 'purchase_tickets' || _vm.type === 'reserve_tickets')?_c('EntityAccessTypeTicketIcon'):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }